// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISubscribeRequestSchema {
  /**  Email, на который оформляется подписка  **/
  email: string;
  /**  Id сущности  **/
  entityId: number;
  /**  Тип сущности  **/
  entityType: EEntityType;
}
export enum EEntityType {
  /** Риелтор **/
  'Agent' = 'agent',
  /** Новостройки **/
  'Newbuilding' = 'newbuilding',
}
